<div class="add-daily-meal-wrapper">
  <div class="heading-section flex flex-col md:flex-row">
    <div class="form-wrapper">
      <div class="heading ">
        Enter Food and Drink
      </div>
      <div class="separator-wrapper">
        <hr class="separator">
      </div>
      <div class="p-10">
        <div class="form-control w-full flex justify-between items-center">
                    <span class="form-label min-w-[28%] max-w-[28%]">
                        Meal<span class="asterisk ml-[0.5rem]">*</span>
                    </span>
          <app-filter-dropdown [enableClearSelection]="true" [loading]="mealTypeLoading" [options]="mealType"
                               [parentFormGroup]="form" class="min-w-[70%] max-w-[70%] form-field"
                               controlName="mealType"
                               [error]="errorMessages['mealType']"
                               placeholder="Select one"
                               type="small">
          </app-filter-dropdown>
        </div>
        <div class="form-control w-full flex justify-between items-center">
                    <span class="form-label min-w-[28%] max-w-[28%] flex items-center gap-[0.5rem]">
                        Food<span class="asterisk ml-[0.5rem]">*</span>
                        <app-icon
                          [matTooltip]="foodSearchTooltip"
                          class="tooltip-icon"
                          matTooltipClass="custom-tooltip food-search-tooltip"
                          matTooltipPosition="below"
                          svgIcon="info"
                        />
                    </span>
          <app-text-input [parentFormGroup]="form" class="min-w-[70%] max-w-[70%] form-field"
                          controlName="name"
                          [error]="errorMessages['name']"
                          placeholder="Add Food"
                          type="small">
          </app-text-input>
        </div>
        <div class="form-control w-full flex justify-between items-center">
                    <span class="form-label min-w-[28%] max-w-[28%]">
                        No. of servings<span class="asterisk ml-[0.5rem]">*</span>
                    </span>
          <app-number-input [parentFormGroup]="form" class="min-w-[70%] max-w-[70%] form-field"
                            controlName="quantity"
                            [error]="errorMessages['quantity']"
                            placeholder="Enter No. of Servings" type="small">
          </app-number-input>
        </div>
        <div class="form-control w-full flex justify-between items-center">
                    <span class="form-label min-w-[28%] max-w-[28%]">
                        Color<span class="asterisk ml-[0.5rem]">*</span>
                    </span>
          <app-filter-dropdown [enableClearSelection]="true" [loading]="colorTypeLoading"
                               [options]="colorType" [parentFormGroup]="form" class="min-w-[70%] max-w-[70%] form-field"
                               controlName="color"
                               [error]="errorMessages['color']"
                               placeholder="Select one" type="small">
          </app-filter-dropdown>
        </div>
        <div class="form-control w-full flex justify-between items-center">
                    <span class="form-label min-w-[28%] max-w-[28%]">
                        Comments
                    </span>
          <app-text-area-input [parentFormGroup]="form"
                               class="min-w-[70%] max-w-[70%] form-field"
                               controlName="comments"
                               placeholder="Add comments (optional)"
                               type="small"
                               [maxLength]="2000">
          </app-text-area-input>
        </div>
      </div>

      <div class="separator-wrapper">
        <hr class="separator">
      </div>
      <div class="w-full">
        <div class="flex justify-end button-wrapper">
          <app-icon *ngIf="!form.invalid" (click)="addData()"
                    class="action-icon"
                     svgIcon="check-circle"></app-icon>
          <app-icon *ngIf="form.invalid"
                    class="action-icon"
                    svgIcon="check-circle-disabled"></app-icon>
          <app-icon (click)="closeModel()" class="action-icon close-icon"
                    svgIcon="cross-red-circle"></app-icon>
        </div>
      </div>
    </div>
    <div class="section-wrapper">
      <div class="heading ">
        Select Food
      </div>
      <div class="separator-wrapper">
        <hr class="separator">
      </div>
      <div
        (scrolled)="onScroll()"
        [infiniteScrollDistance]="2"
        [infiniteScrollThrottle]="10"
        [scrollWindow]="false"
        class="table-wrapper overflow-y-scroll"
        infiniteScroll
      >
        <table [dataSource]="dataSource" mat-table>
          <ng-container [sticky]="true" matColumnDef="foodItem">
            <th *matHeaderCellDef class="min-w-[20rem] max-w-[20rem]" mat-header-cell>
              <div class="th-cell">
                Food Item
              </div>
            </th>
            <td *matCellDef="let eachRow;let index=index" mat-cell class="min-w-[20rem] max-w-[20rem]">
              <div class="td-cell">
                <div class="daily-tracker-title text-wrapper">
                  {{eachRow?.name}}
                </div>
              </div>
            </td>
          </ng-container>

          <ng-container matColumnDef="servingQuantity">
            <th *matHeaderCellDef class="min-w-[15rem] max-w-[15rem]"
                mat-header-cell>
              <div class="th-cell daily-tracker-title">
                Serving size
              </div>
            </th>
            <td *matCellDef="let eachRow" mat-cell
                class="min-w-[15rem] max-w-[15rem]">
              <div class="td-cell daily-tracker-content daily-tracker-title text-wrapper">
                {{eachRow?.servingAmount}} {{eachRow?.servingUnit}}
              </div>
            </td>
          </ng-container>
          <ng-container matColumnDef="servingType">
            <th *matHeaderCellDef class="min-w-[10rem] max-w-[10rem]" mat-header-cell>
              <div class="th-cell daily-tracker-title">
                Serving Unit
              </div>
            </th>
            <td *matCellDef="let eachRow" mat-cell class="min-w-[10rem] max-w-[10rem]">
              <div class="td-cell daily-tracker-content daily-tracker-title">

                {{eachRow?.servingUnit }}
              </div>
            </td>
          </ng-container>
          <ng-container matColumnDef="color">
            <th *matHeaderCellDef class="min-w-[10rem] max-w-[10rem]" mat-header-cell>
              <div class="th-cell daily-tracker-title">
                Color
              </div>
            </th>
            <td *matCellDef="let eachRow" mat-cell class="min-w-[10rem] max-w-[10rem]">
              <div class="td-cell daily-tracker-content daily-tracker-title text-wrapper">
                <app-icon class="light-icon" *ngIf="eachRow.color === 'Red'" svgIcon="red-light"></app-icon>
                <app-icon class="light-icon" *ngIf="eachRow.color === 'Green'" svgIcon="green-light"></app-icon>
                <app-icon class="light-icon" *ngIf="eachRow.color === 'Yellow'" svgIcon="yellow-light"></app-icon>
              </div>
            </td>
          </ng-container>
          <tr *matHeaderRowDef="colDef; sticky: true" mat-header-row></tr>
          <tr *matRowDef="let row; columns: colDef;" mat-row></tr>
        </table>
        <div *ngIf="loading" [ngClass]="{ 'initial': !dataSource?.data?.length }"
             class="table-loader w-full flex justify-center items-center">
          <mat-spinner/>
        </div>
        <div *ngIf="!dataSource?.length && !loading" class="no-data flex flex-col justify-center items-center">
          <div class="text">
            No Data Found
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
